import { useParams } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleBody from '@/components/feature/ArticleBody';
import ShareBar from '@/components/feature/ShareBar';
import RelatedSection from '@/components/feature/RelatedSection';
import HotSidebar from '@/components/feature/HotSidebar';
import NotFoundState from '@/components/feature/NotFoundState';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import { formatViews, getItemById, getItemsByType, getRelated } from '@/utils/content';

export default function EntertainmentDetail() {
  const { id = '' } = useParams();
  const item = getItemById('entertainment', id);

  useDocumentMeta({
    title: item ? `【${item.title}】 - 91网站` : '娱乐内容详情 - 91网站',
    description: item ? item.summary : '91网站娱乐内容详情页。',
    keywords: item ? item.tags?.join(',') || '91网站,娱乐内容' : '91网站,娱乐内容',
  });

  if (!item) {
    return (
      <SiteLayout>
        <NotFoundState
          message="该娱乐内容不存在或已下线，请返回娱乐频道浏览其他内容。"
          backTo="/category/entertainment"
          backLabel="返回娱乐频道"
          secondaryTo="/"
          secondaryLabel="返回首页"
        />
      </SiteLayout>
    );
  }

  const related = getRelated(item, 4);
  const hot = [...getItemsByType('entertainment')].sort((a, b) => (b.views || 0) - (a.views || 0)).slice(0, 6);

  return (
    <SiteLayout>
      <div className="mx-auto max-w-[1440px] px-4 py-6 md:px-6 md:py-8">
        <Breadcrumb items={[{ label: '娱乐频道', to: '/category/entertainment' }, { label: item.title }]} />

        <div className="mt-4 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-8">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-secondary-900 px-3 py-1 text-xs font-medium text-background-50">
                  {item.subCategory}
                </span>
                <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                  {item.genre}
                </span>
              </div>
              <h1 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[32px]">
                {item.title}
              </h1>
              <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 border-b border-background-200 pb-4 text-xs text-secondary-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-live-line"></i>
                  {item.source}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line"></i>
                  发布时间：{item.publishTime}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line"></i>
                  {formatViews(item.views)}
                </span>
              </div>

              <div className="mt-6">
                <ArticleBody content={item.content} image={item.image} imageAlt={item.title} />
              </div>

              {item.tags && item.tags.length > 0 && (
                <div className="mt-8 flex flex-wrap items-center gap-2">
                  <span className="text-xs text-secondary-500">相关话题：</span>
                  {item.tags.map((tag) => (
                    <span key={tag} className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-700">
                      #{tag}
                    </span>
                  ))}
                </div>
              )}

              <div className="mt-6 border-t border-background-200 pt-5">
                <ShareBar title={item.title} />
              </div>
            </div>
          </div>

          <aside className="lg:col-span-4">
            <HotSidebar title="娱乐热榜" items={hot} />
          </aside>
        </div>

        <RelatedSection title="相关推荐内容" items={related} moreTo="/category/entertainment" />
      </div>
    </SiteLayout>
  );
}